import React from 'react';
import { Box, BoxProps, ToggleButton, ToggleButtonProps } from '@mui/material';
import { TranslatedText, XOR } from '@ianesthesie-kit/core';
import { useFormikContext } from 'formik';
import get from 'lodash/fp/get';

export type ToggleProps = Omit<ToggleButtonProps, 'value' | 'onChange'> & {
  value: boolean;
  onChange: (value: boolean) => void;
  toggledOnColor?: ToggleButtonProps['color'];
  toggledOffColor?: ToggleButtonProps['color'];
} & XOR<
    { textId: string },
    { toggledOnTextId: string; toggledOffTextId: string }
  >;

const Toggle = ({
  value,
  onChange,
  textId,
  toggledOnTextId,
  toggledOffTextId,
  color = 'primary',
  toggledOffColor,
  toggledOnColor,
  ...props
}: ToggleProps) => (
  <ToggleButton
    value={!!value}
    color={value ? toggledOnColor ?? color : toggledOffColor ?? color}
    selected={!!value}
    onChange={() => onChange(!value)}
    size="small"
    {...props}
  >
    <TranslatedText
      id={value ? toggledOnTextId ?? textId : toggledOffTextId ?? textId}
    />
  </ToggleButton>
);

type FormToggleButtonProps = Omit<ToggleProps, 'value' | 'onChange'> & {
  name: string;
  wrapperProps?: Omit<BoxProps, 'children'>;
};

export const FormToggleButton = ({
  name,
  wrapperProps,
  ...props
}: FormToggleButtonProps) => {
  const { values, setFieldValue } = useFormikContext();
  const value = get(name, values);

  return (
    <Box mt={1} mb={0.5} {...wrapperProps}>
      <Toggle
        value={value}
        onChange={(v) => setFieldValue(name, v)}
        {...(props as any)}
      />
    </Box>
  );
};
